(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, { once:true }) : fn();

  const initActivityTabs = (scope=document) => {
    scope.querySelectorAll('[data-vv-activity-tabs]:not([data-vv-ready])').forEach((section) => {
      section.dataset.vvReady = 'true';
      const tabs = Array.from(section.querySelectorAll('[data-vv-activity-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-vv-activity-panel]'));
      const activate = (index, focus=false) => {
        tabs.forEach((tab,i) => {
          const active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true':'false');
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel,i) => {
          const active = i === index;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
        if (focus) tabs[index]?.focus({preventScroll:true});
      };
      tabs.forEach((tab,index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activate(next,true);
        });
      });
      activate(Math.max(0,tabs.findIndex(t => t.classList.contains('is-active'))));
    });
  };

  const initScrollers = (scope=document) => {
    scope.querySelectorAll('[data-vv-rich-scroller]:not([data-vv-scroller-ready])').forEach((root) => {
      root.dataset.vvScrollerReady='true';
      const track = root.querySelector('[data-vv-rich-track]');
      const prev = root.querySelector('[data-vv-rich-prev]');
      const next = root.querySelector('[data-vv-rich-next]');
      const move = (direction) => {
        if (!track) return;
        const card = track.firstElementChild;
        const amount = card ? card.getBoundingClientRect().width + 14 : track.clientWidth * .8;
        track.scrollBy({left:direction * amount,behavior:'smooth'});
      };
      prev?.addEventListener('click',()=>move(-1));
      next?.addEventListener('click',()=>move(1));
    });
  };

  const init = (scope=document) => { initActivityTabs(scope); initScrollers(scope); };
  ready(() => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
